import React,{useState} from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { Link } from "react-router-dom";
import { environment } from '../environment/production';
import './Home.css';

function OTP() {
  const location = useLocation();

    const [errorMsg,setErrorMsg]=useState(
        {
          email: '',
        password: ''
      })
      const [formdata, setFormData] = useState({
        email_id:location.state==null?'':location.state.email,
        otp: '',
      });
      const navigate = useNavigate();
  
  const options={
    data:{
      formdata
    },
    headers:{
      'Content-type':'application/json',
    }
  }
  function handleValidation(){
    if(formdata.otp ==''){
        setErrorMsg({otp:'OTP is required'})
      }else{
      
     if( formdata.otp ==''){
     // alert("Email is required")
     setErrorMsg({otp:'OTP is required'})
     }
    }
    if(formdata.otp !==''){
        axios.post(environment.apiUrl+`/User/validateOTP`,JSON.stringify(options.data.formdata),{headers:JSON.stringify(options.headers)})
  .then((response)=>{
  
     if(response['data']['status']=="1"){
      alert(response['data']['msg'])
       navigate("/login")
     }else{
       alert(response['data']['msg'])
       //setErrorMsg({wrongLogin:response['data']['msg']})
       navigate("/otp")
     }
  })
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    //console.log(e.target.appl_recvd_d.value);
    formdata.otp=e.target.otp.value;
    
    setFormData(...[formdata]);
    /* axios api post */
    handleValidation();
    
    };
  return (
    <>
 <div className="login-page login-page9">   {/* style={{ backgroundImage: `url('./gstn.png')` }} */}
     <div className="login-page9-wrapper">
    
      <form action="" onSubmit={handleSubmit}>
     
          <header> 
            <h4>OTP Sent To Your Registered Email Id</h4>
          </header>
          
          <br/>
          <span style={{color:'red'}}>{errorMsg.otp}</span>
          <label className="rlp-username">
            <input placeholder="Enter OTP" index="1" name="otp" />
          </label>
         
          <section>
          <button type="submit">Submit</button></section>
         
      </form>
    </div>
    </div>
    </>
  )
}

export default OTP